module.exports = __webpack_public_path__ + "static/media/toaster-error-close.73202300.svg";